import {
  Button,
  Badge,
  BadgeGroup,
  NavBar,
  Row,
  Col,
  Card,
  Tag,
  Icon,
  Cell,
  CellGroup,
  Panel,
  Dialog,
  Swipe,
  Toast,
  SwipeItem,
  SubmitBar,
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  AddressEdit,
  Slider,
  Stepper,
  Steps,
  Pagination,
  Area,
  // Lazyload,
  PullRefresh,
  Actionsheet,
  Progress
} from 'vant'

// 基础元件
import KNoData from './k/k-no-data' // 无数据
import KDivider from './k/k-hr' // 水平分隔线或块
import KLoading from './k/k-loading'
import KTime from './k/k-time'
import KDlg from './k/k-dlg'
import KChk from './k/k-chk'
import KBtn from './k/k-btn'
import KNum from './k/k-num'
import KMoney from './k/k-money'
import KPanel from './k/k-panel'
import KUser from './k/k-user'
import KLeftTime from './k/k-left-time'

// wz
import WZCommentItem from './wz/wz-comment-item'
import WZCommentPost from './wz/wz-comment-post'
import WZCommentList from './wz/wz-comment-list'


import { isArray, forEach, isPlain } from '../utils/base'

export default Vue => {
  function register(O) {
    if (isArray(O)) {
      forEach(O, o => {
        if (!o.name) {
          throw o
        }
        Vue.component(o.name, o)
      })
    } else if (isPlain(O)) {
      forEach(O, (o, name) => {
        Vue.component(name, o)
      })
    }
  }
  register([
    Button,
    Badge,
    BadgeGroup,
    Row,
    Col,
    Card,
    Tag,
    Icon,
    Toast,
    Cell,
    CellGroup,
    Swipe,
    SwipeItem,
    Dialog,
    GoodsAction,
    GoodsActionBigBtn,
    GoodsActionMiniBtn,
    SubmitBar,
    NavBar,
    Panel,
    Tab,
    Tabs,
    Tabbar,
    TabbarItem,
    Slider,
    Stepper,
    Steps,
    Pagination,
    Area,
    AddressEdit,
    // Lazyload, // 该组件没有 name 值
    PullRefresh,
    Actionsheet,
    Progress,

    // 基础元件
    KNoData,
    KDivider,
    KLoading,
    KTime,
    KDlg,
    KChk,
    KBtn,
    KNum,
    KMoney,
    
    KPanel,
    KUser,
    KLeftTime,
   

    // 王者组件
    WZCommentItem,
    WZCommentList,
    WZCommentPost,

  ])
}
